<template>
  <section class="closing" id="contact">
    <div class="shell">
      <span class="eyebrow">ДЕРЖИТЕ ВАЖНОЕ В ПОЛЕ ЗРЕНИЯ</span>
      <h2>Хорошо, когда<br /><span class="gradient-text">всё спокойно</span></h2>
      <NuxtLink class="button button-white" to="/contacts">Обсудить проект</NuxtLink>
      <p>Санкт-Петербург и Ленинградская область</p>
    </div>
  </section>
</template>
